import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStatus } from '../hooks/useAuthStatus';
import Spinner from './Spinner';

export default function AdminRoute() {
  const { loggedIn, isAdmin, checkingStatus } = useAuthStatus();

  console.log('🔐 AdminRoute - Checking status:', checkingStatus);
  console.log('🔐 AdminRoute - Logged in:', loggedIn);
  console.log('🔐 AdminRoute - Is Admin:', isAdmin);

  if (checkingStatus) {
    console.log('⏳ AdminRoute - Checking, showing spinner...');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner />
        <p className="ml-4 text-gray-600">Verifying admin access...</p>
      </div>
    );
  }

  if (!loggedIn) {
    console.log('❌ AdminRoute - Not logged in, redirecting to sign-in');
    return <Navigate to="/sign-in" />;
  }

  if (!isAdmin) {
    console.log('❌ AdminRoute - Not admin, redirecting to home');
    return <Navigate to="/" />;
  }

  console.log('✅ AdminRoute - Admin verified, rendering outlet');
  return <Outlet />;
}
